import cn from '@/lib/cs';
import React from 'react';

const ExpertIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="m12.4 24 2-.3 1.8-1 1.5-1.5 1.6-1.1 1-1.9 1-1.6.8-1.9.2-2 .5-1.9V8.6l-.2-2.2-.1-2-1.9-1-2-.8-2-1.2-2.1-.7-2-.7-2.2.4-2 1-2.1.8-2 1-2 1L2 6.4l.1 2.2.2 2.2.2 2v2l1 1.8 1 1.7 1 1.8L7 21.4l1.8 1 1.8 1 1.8.6Zm8.1-13-.6 2-.4 2-.7 2-1.5 1.4-1.1 1.7-1.8 1-2 .8-2-.6L9 19.9l-1.4-1.5-1.3-1.5L5 15l-.4-2-.4-2 .4-1.8-.3-1.8-.1-2L6.6 5l2-1 2-.7 1.8-1 2 .8 2 1 2 .7 2 .8.1 1.9-.3 1.8.3 1.8Zm-3.8 6.6-2-1.5-2.3-1-2 1.3-2 1 .2-2.2.7-2.2-1.8-1.5-2-1.6H8l2.5-.2.9-2.3 1-2.3 1 2.3 1 2 2.3.5h2.5l-1.8 1.7-2.2 1.3.6 2.4.8 2.3Z"
			clipRule="evenodd"
		/>
	</svg>
);

export default ExpertIcon;
